import React, { useEffect } from "react";
import SmoothScroll from "smooth-scroll";
import AdUnit from "./AdUnit"; // 👈 import your ad unit

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const Dashboard = () => {

  useEffect(() => {
    // window.location.href = "https://play.google.com/store/apps/details?id=com.ganeshshiva.goglobal";
  }, []);

  return (
    <>
      {/* ✅ Top Banner Ad */}
      <AdUnit adSlot="6206103661" />

      <div className="bg-white min-h-screen px-4 py-6 flex justify-center">
        <div className="w-full max-w-screen-xl">
          
          {/* ✅ Inline Ad */}
          <AdUnit adSlot="6301472438" />

          {/* Top Section */}
          <div className="flex flex-col-reverse md:flex-row w-full gap-6">
            {/* Text Section */}
            <div className="w-full md:w-3/5 lg:w-4/5 flex flex-col justify-start">
              <h1 className="text-2xl md:text-5xl font-bold mt-4 md:mt-0">OmiChat</h1>
              <p className="text-green-700 text-sm md:text-base">KRISH TECHX</p>
              <p className="text-xs text-gray-500">Contains ads</p>

              {/* Ratings Row */}
              <div className="flex gap-6 mt-4 text-xs md:text-sm text-gray-700">
                <div className="text-center">
                  <p className="font-semibold">4.5★</p>
                  <p>41 reviews</p>
                </div>
                <div className="text-center">
                  <p className="font-semibold">10K+</p>
                  <p>Downloads</p>
                </div>
                <div className="text-center">
                  <p className="font-semibold">18+</p>
                  <p>Rated for 18+</p>
                </div>
              </div>

              {/* Install Button */}
              <button
                className="w-full md:w-48 mt-4 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg text-sm shadow"
                onClick={() => {
                  window.location.href =
                    "https://play.google.com/store/apps/details?id=com.ganeshshiva.goglobal";
                }}
              >
                Install
              </button>

              {/* Share & Wishlist */}
              <div className="flex gap-6 mt-3 text-blue-600 text-sm font-medium">
                <button>Share</button>
                <button>Add to wishlist</button>
              </div>

              <p className="mt-2 text-xs text-gray-500">
                This app is available for your device
              </p>
            </div>

            {/* Image Section */}
            <div className="w-full md:w-2/5 lg:w-1/5 flex justify-center md:justify-start mb-4 md:mb-0">
              <img
                src="/img/logo.png"
                alt="OmiChat Icon"
                className="w-24 h-24 md:w-36 md:h-36 rounded-2xl shadow"
              />
            </div>
          </div>

          {/* Screenshots */}
          <div className="mt-8 overflow-x-auto">
            <div className="flex gap-4">
              {Array.from({ length: 9 }).map((_, i) => (
                <img
                  key={i}
                  src={`/img/portfolio/${i + 1}.jpg`}
                  alt={`Screenshot ${i + 1}`}
                  className="h-64 md:h-80 w-auto object-cover rounded-lg border"
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Bottom Banner Ad */}
      <AdUnit adSlot="6301472438" />
    </>
  );
};

export default Dashboard;
